import { CommonResponse, RmBudgetRequest, RmBudgetResponseModel } from "@gtpl/shared-models/masters";

import axios from "axios";
import { connection } from "./connection";
import { RmBudgetInfoReq } from "@gtpl/shared-models/raw-material-procurement";


export class RmBudgetServices{
  
    URL = connection.DEPLOY_URL + '/rmBudget';

    async createRmBudget(req:RmBudgetRequest): Promise<RmBudgetResponseModel> {
        return await axios.post(this.URL + '/createRmBudget',req)
            .then(res => {
                return res.data
            })
    }

    async getAllRmBudget(): Promise<CommonResponse> {
        return await axios.post(this.URL + "/getAllRmBudget")
        .then(res => {
            return res.data
          })
    }
    async getBudgetRangeAgainstCount(req:RmBudgetInfoReq): Promise<CommonResponse> {
        return await axios.post(this.URL + "/getBudgetRangeAgainstCount",req)
        .then(res => {
            return res.data
          })
    }
}